import React, { createContext, useReducer } from 'react'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'set_graph_missing_images_data': {
      return { ...data, data: payload.data }
    }
    case 'set_selected_graph_missing_images_data': {
      return { ...data, selectedObject: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedObject: {},
}

const GraphMissingImagesStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <GraphMissingImagesContext.Provider value={[state, dispatch]}>
      {children}
    </GraphMissingImagesContext.Provider>
  )
}

export const GraphMissingImagesContext = createContext(initialState)
export default GraphMissingImagesStore
